export { default } from './InputAdornment';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/InputAdornment/index.js
// module id = 132
// module chunks = 0